// frontend/src/components/RoleProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const RoleProtectedRoute = ({ children, role: requiredRole }) => {
  const token = localStorage.getItem("token");

  // If no token exists, redirect to the login page
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  try {
    // Decode the token to get user information
    const decoded = jwtDecode(token);
   

    // Check if the user role matches the required role
    if (decoded.role !== requiredRole) {

      return children;

      // Optionally, you can redirect to an "Unauthorized" page
    } else return <Navigate to="/" replace />;
  } catch (error) {
    console.error("Token decoding error:", error);
    return <Navigate to="/login" replace />;
  }

  // If everything is good, render the child components
};

export default RoleProtectedRoute;
